export default "__VITE_ASSET__CQg0LkVg__"